// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d530cf06","239":"da76077e","453":"2427a9a3","455":"8ccad5fc"}[chunkId] + ".chunk.js";
};